(function () {
  function initDrawerSplitButton() {
    const summaries = document.querySelectorAll(
      '.menu-drawer__menu-item--mainlist[data-url], .menu-drawer__menu-item--parent[data-url]'
    );

    summaries.forEach((summary) => {
      if (summary.dataset.splitInit) return;
      summary.dataset.splitInit = 'true';

      const url = summary.dataset.url;
      if (!url || url === '#') return;

      const titleSpan = summary.querySelector('.menu-drawer__menu-item-text');
      if (!titleSpan) return;

      titleSpan.style.cursor = 'pointer';
      titleSpan.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        window.location.href = url;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initDrawerSplitButton);
  document.addEventListener('shopify:section:load', initDrawerSplitButton);
})();

function initVipBadge() {
  const script = document.querySelector('script[data-is-vip]');
  const isVip = script?.dataset.isVip === 'true';
  if (!isVip) return;

  const accountButton = document.querySelector('shopify-account');
  if (!accountButton || document.querySelector('.vip-account-badge')) return;

  const badge = document.createElement('span');
  badge.className = 'vip-account-badge';
  badge.textContent = '★';
  accountButton.insertAdjacentElement('afterend', badge);
}

document.addEventListener('DOMContentLoaded', initVipBadge);

(function () {
  function hideProfilLink() {
    if (window.customerLoggedIn) return;
    
    const accountEl = document.querySelector('shopify-account');
    if (!accountEl?.shadowRoot) return false;
    
    const link = accountEl.shadowRoot.querySelector('a[href="/pages/profil-vervollstndigen"]');
    if (link) {
      link.closest('.account__item-wrapper')?.remove();
      return true;
    }
    return false;
  }

  function watchForProfilLink() {
    if (hideProfilLink()) return;

    const observer = new MutationObserver(() => {
      if (hideProfilLink()) observer.disconnect();
    });

    const accountEl = document.querySelector('shopify-account');
    if (accountEl?.shadowRoot) {
      observer.observe(accountEl.shadowRoot, { childList: true, subtree: true });
    } else {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', watchForProfilLink);
})();

